import { Controller } from "@hotwired/stimulus";

/**
 Sets a flag to skip scroll after morph for app/javascript/entrypoints/users.js
 to use.

 After scroll to top is skipped, the flag is unset automatically.
**/
export default class extends Controller {
  setSkipScroll() {
    window.temporarySkipScrollAfterMorph = true;
  }

  unsetSkipScroll() {
    window.temporarySkipScrollAfterMorph = false;
  }
}
